/** Paths for tenant legal documents (public, no auth shell). */

export function isLegalPath(pathname: string): boolean {
  const path = pathname || '/'
  return path === '/legal/privacy' || path === '/legal/terms'
}
